// PrivacyPage.js
import React from "react";
import CONFIG from "./config";

const PrivacyPage = () => {
  return (
    <div>
      <div style={styles.container}>
        <div style={styles.topSection}>
          <p style={styles.logo}>
            <a href={`${CONFIG.FRONTEND_URL}`} style={{ textDecoration: "none", color: "inherit" }}>
              Rili Day
            </a>
          </p>
          <button 
            style={styles.homeButton}
            onClick={() => window.location.href = `${CONFIG.FRONTEND_URL}`}
          >
            Home Page
          </button>
        </div>
        <h1 style={styles.title}>Privacy Policy</h1>

        <p style={styles.subtitle}><strong>Effective Date:</strong> February 2025</p>

        <section style={styles.section}>
          <h2>1. Introduction</h2>
          <p>Welcome to Rili Day (www.rili.day). By using our website or services, you acknowledge that you have read and understood this Privacy Policy. This policy explains what information we collect, how we use it, and your rights regarding your personal data.</p>
        </section>

        <section style={styles.section}>
          <h2>2. Types of Users</h2>
          <p>Rili Day serves two main user groups:</p>
          <ul style={styles.ul}>
            <li>
              <strong>Business Owners:</strong> Individuals or entities who register to use our booking and scheduling services to manage their business events and appointments.
            </li>
            <li>
              <strong>Customers (End Users):</strong> Individuals who interact with the Business Owners, such as booking appointments or submitting service requests through Rili Day.
            </li>
          </ul>
        </section>

        <section style={styles.section}>
          <h2>3. Information We Collect</h2>
          <p>We collect both Business Owners' and Customers' data for the purpose of providing and improving our services:</p>
          <ul style={styles.ul}>
            <li><strong>Email Address &amp; Password:</strong> For Business Owners to create and manage an account.</li>
            <li><strong>Timezone &amp; Usage Data:</strong> To provide accurate scheduling and analytics.</li>
            <li><strong>Customer Data:</strong> Including names, emails, and phone numbers submitted when booking events or services.</li>
            <li><strong>Cookies:</strong> We use cookies to enhance user experience, analyze site traffic, and personalize content.</li>
          </ul>
        </section>

        <section style={styles.section}>
          <h2>4. How We Use Your Information</h2>
          <p>Rili Day uses the information provided for:</p>
          <ul style={styles.ul}>
            <li>Verifying registration through email confirmation.</li>
            <li>Sending service request notifications and appointment reminders.</li>
            <li>Providing account management features, including self-service account deletion.</li>
            <li>Facilitating event notifications between Business Owners and their Customers.</li>
            <li>Improving our website and services through analytics and user feedback.</li>
          </ul>
          <p><strong>Note for Customers:</strong> If you submit your information to a Business Owner via Rili Day, your data (such as name, email, phone) is forwarded to that Business Owner. Rili Day does not control how Business Owners use that data once they receive it.</p>
        </section>

        <section style={styles.section}>
          <h2>5. Cookies and Tracking Technologies</h2>
          <p>We use cookies and similar tracking technologies to track the activity on our service and store certain information. Cookies are files with a small amount of data which may include an anonymous unique identifier. You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent. However, if you do not accept cookies, you may not be able to use some portions of our service.</p>
          <p>Types of cookies we use:</p>
          <ul style={styles.ul}>
            <li><strong>Essential Cookies:</strong> Necessary for the operation of our website.</li>
            <li><strong>Performance Cookies:</strong> Help us understand how visitors interact with our website by collecting and reporting information anonymously.</li>
            <li><strong>Functionality Cookies:</strong> Used to remember user preferences and settings.</li>
            <li><strong>Targeting Cookies:</strong> Used to deliver relevant advertisements to users.</li>
          </ul>
        </section>

        <section style={styles.section}>
          <h2>6. Data Protection &amp; Retention</h2>
          <p>We store and process data in compliance with GDPR, Canada's PIPEDA, and relevant US privacy laws. We implement appropriate measures to safeguard the data we manage.</p>
          <p>Data is retained only as long as it is necessary for our services or as required by law. Business Owners' data is retained for account management and operational purposes. Customer data is retained only for event scheduling and notifications, unless removed upon request.</p>
        </section>

        <section style={styles.section}>
          <h2>7. User Rights</h2>
          <ul style={styles.ul}>
            <li><strong>Business Owners:</strong> Can delete their accounts at any time, removing all associated data except where legally required to retain records.</li>
            <li><strong>Customers:</strong> May request the removal of their data from Rili Day by contacting <a href="mailto:mail@rili.day">mail@rili.day</a>. However, data already shared with a Business Owner is beyond our control.</li>
            <li><strong>Access and Correction:</strong> Users have the right to access and correct their personal data.</li>
            <li><strong>Data Portability:</strong> Users can request a copy of their data in a structured, commonly used format.</li>
          </ul>
        </section>

        <section style={styles.section}>
          <h2>8. Third-Party Services</h2>
          <p>We may employ third-party companies and individuals to facilitate our service, provide the service on our behalf, perform service-related services, or assist us in analyzing how our service is used. These third parties have access to your personal data only to perform these tasks on our behalf and are obligated not to disclose or use it for any other purpose.</p>
        </section>

        <section style={styles.section}>
          <h2>9. Unsubscribe &amp; Email Preferences</h2>
          <p>All emails sent to Customers include an <strong>"Unsubscribe"</strong> button. If you did not expect the email or wish to opt out of further communications from a specific business, clicking "Unsubscribe" adds your address to our unsubscribed database for that particular business. This ensures you no longer receive event notifications or reminders from that business via Rili Day.</p>
          <p>If you have any questions about unsubscribing, please contact <a href="mailto:mail@rili.day">mail@rili.day</a>.</p>
        </section>

        <section style={styles.section}>
          <h2>10. Consent</h2>
          <p>By using Rili Day, you consent to receive email communications for account verification, service updates, and appointment reminders, or event notifications. This consent may be withdrawn at any time by unsubscribing or requesting data removal.</p>
        </section>

        <section style={styles.section}>
          <h2>11. Changes to This Privacy Policy</h2>
          <p>We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page. You are advised to review this Privacy Policy periodically for any changes. Changes to this Privacy Policy are effective when they are posted on this page.</p>
        </section>

        <section style={styles.section}>
          <h2>12. Contact Us</h2>
          <p>If you have questions or need assistance regarding your privacy rights, please contact us at <a href="mailto:mail@rili.day">mail@rili.day</a>.</p>
        </section>
      </div>
      <div style={styles.footer}>
        <p>
          <a href={`${CONFIG.FRONTEND_URL}/privacy`}>Privacy Policy</a>
          {" "}|{" "}
          <a href={`${CONFIG.FRONTEND_URL}/terms`}>Terms of Service</a>
        </p>
      </div>
    </div>
  );
};

const styles = {
  container: {
    maxWidth: "800px",
    margin: "0 auto",
    padding: "20px",
    fontFamily: "Arial, sans-serif",
    lineHeight: "1.6",
    color: "#333"
  },
  title: {
    fontSize: "32px",
    marginBottom: "10px"
  },
  subtitle: {
    fontSize: "14px",
    marginBottom: "20px",
    color: "#555"
  },
  section: {
    marginBottom: "20px",
    textAlign: "justify"
  },
  ul: {
    marginLeft: "20px",
    listStyleType: "disc"
  },
  footer: {
    marginTop: "50px",
    padding: "0px",
    backgroundColor: "rgb(226, 218, 195)",
    textAlign: "center",
    width: "100%",
    display: "flex",
    justifyContent: "center",
    fontSize: "12px",
    height: "40px"
  },
  topSection: {
    display: "flex", 
    justifyContent: "space-between", 
    paddingBottom: "20px",
    paddingTop: "10px",
    maxWidth: "800px",
    margin: "0 auto",
    lineHeight: "1.6",
    fontFamily: "Arial, sans-serif",
  },
  logo: {
    fontFamily: "Verdana, sans-serif", // Ensures a sans-serif fallback
    fontWeight: "bold", // Makes the text bold
    fontSize: "24px", // Adjust size as needed
    color: "#2c3e50", // Adjust color as needed
    margin: "0px",
  },  
  homeButton: {
    backgroundColor: "#2c3e50",
    color: "#fff",
    padding: "10px 20px",
    borderRadius: "5px",
    cursor: "pointer"
  }
};

export default PrivacyPage;
